const ResearchTrainingCard =()=>{
    return(
        <>
            <div className="row">
                <div className="col-12">
                    <div className="t-block">
                        <div className="t-block__content">
                            <div class="t-block_list ms-lg-0 slow-up-down">
                                <div class="t-block__list--image">
                                    <figure class="ripple-effect overlay">
                                        <img src="https://www.hbku.edu.qa/sites/default/files/img-include-1.png" alt="" class="full-width" />
                                    </figure>
                                </div>
                                <div class="t-block__list__info">
                                    <div class="t-block__list--title">
                                        <h4 class="item--title">Research and Publishing Skills</h4>
                                    </div>
                                    <div class="t-block__list--content">
                                        <div className="l-article">
                                            <ul>
                                                <li>Scientific writing and manuscript structure</li>
                                                <li>Choosing the right journal</li>
                                                <li>Understanding editorial decisions</li>
                                                <li>Responding to reviewers</li>
                                                <li>Navigating the peer-review process</li>
                                            </ul>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>

                            <div class="t-block_list slow-up-down">
                                <div class="t-block__list--image">
                                    <figure class="ripple-effect overlay">
                                        <img src="https://www.hbku.edu.qa/sites/default/files/img-include-2.png" alt="" class="full-width" />
                                    </figure>
                                </div>
                                <div class="t-block__list__info">
                                    <div class="t-block__list--title">
                                        <h4 class="item--title">Career and Professional Development</h4>
                                    </div>
                                    <div class="t-block__list--content">
                                        <div className="l-article">
                                            <ul>
                                                <li>Research career planning</li>
                                                <li>Effective scientific communication</li>
                                                <li>Collaboration and team science</li>
                                                <li>Leadership and mentoring</li>
                                                <li>Preparing for academic interviews and positions</li>
                                            </ul>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>

                            <div class="t-block_list slow-up-down">
                                <div class="t-block__list--image">
                                    <figure class="ripple-effect overlay">
                                        <img src="https://www.hbku.edu.qa/sites/default/files/img-include-3.png" alt="" class="full-width" />
                                    </figure>
                                </div>
                                <div class="t-block__list__info">
                                    <div class="t-block__list--title">
                                        <h4 class="item--title">Research Design, Data and Integrity</h4>
                                    </div>
                                    <div class="t-block__list--content">
                                        <div className="l-article">
                                            <ul>
                                                <li>Experimental design and study planning</li>
                                                <li>Data analysis and interpretation</li>
                                                <li>Research integrity and responsible practices</li>
                                                <li>Reproducibility and transparency</li>
                                            </ul>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
           
        
    )
}
export default ResearchTrainingCard;